import type { ReactNode } from 'react';

import type { DashboardWidgetConfig } from 'src/types/dashboard';

/**
 * A simple widget wrapper without any logic.
 * Useful for widgets that consist of multiple smaller
 * widgets and bring their own grid.
 */
export const WidgetGroupGridWrapper = ({
  children,
}: {
  config: DashboardWidgetConfig;
  className: string;
  children: ReactNode;
}) => <>{children}</>;

export default WidgetGroupGridWrapper;
